module.exports = new __parcel__URL__("apply_c_en.a8b4404c.webp").toString();